<template>
  <div>
    <el-row>
      <el-col :span="3" style="text-align: left; padding-left: 10px">
        <!-- <el-checkbox v-model="showSubmodel" label="显示车款" border></el-checkbox> -->
        <el-switch
          v-model="showSubmodel"
          active-color="#ffad53"
          inactive-color="#000"
          active-text="显示车款"
        ></el-switch>
      </el-col>
      <el-col :span="3" style="text-align: left">
        <el-button
          size="mini"
          @click="clearResults"
          type="text"
          v-if="showClearAll"
          style="margin-top: -12px"
        >
          <svg-icon name="trash" size="28" color="#ffad53"></svg-icon>
          <span
            style="
              position: absolute;
              top: 4px;
              font-size: 14px;
              color: #ffad53;
            "
          >
            清空搜索</span
          >
        </el-button>
        &nbsp;
      </el-col>

      <el-col :span="18" style="text-align: right; padding-right: 20px">
        <el-button
          type="primary"
          @click="onAddSelectionResult"
          v-if="showSelectionButton"
          >添加选中车辆</el-button
        >
        <slot name="resultButton"></slot>
        <el-button type="danger" @click="gotoAnalyze" v-if="false"
          >进入分析</el-button
        >
      </el-col>
    </el-row>
    <!-- <p>{{JSON.stringify(selectedResult)}}</p> -->
    <el-table
      style="width: 100%; min-height: 500px; background-color: #fff"
      ref="resultTable"
      :data="displayResult"
      tooltip-effect="dark"
      height="450"
      :paginationShow="true"
      @sort-change="changeTableSort"
      @selection-change="onSelectionChanged"
    >
      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column
        label="厂商"
        prop="manufacturer"
        :filter-method="filterMethod"
        :filters="getFilters('manufacturer')"
      >
      </el-table-column>
      <el-table-column
        label="品牌"
        prop="brand"
        :filter-method="filterMethod"
        :filters="getFilters('brand')"
      >
      </el-table-column>
      <el-table-column
        label="子车型"
        prop="model"
        :width="lineWidth"
        :filter-method="filterMethod"
        :filters="getFilters('model')"
      >
      </el-table-column>
      <el-table-column v-if="showSubmodel" label="车款" width="450" prop="name">
      </el-table-column>
<!-- -->
      <el-table-column v-if="showSubmodel" sortable   label="MSRP" prop="msrp" :sort-method="sortMsrp"  > 
      </el-table-column>

      <el-table-column
        v-if="showSubmodel"
        label="装备装态"
        sortable
        prop="equipstatus"
      ></el-table-column>
      <el-table-column
        label="停产"
        prop="lineStatus"
        v-if="showSubmodel"
        :filter-method="filterMethod"
        sortable
        :filters="getFilters('lineStatus')"
        :filteredValue="['在产']"
      >
      </el-table-column>
      <el-table-column
        label="车款年"
        sortable
        prop="lineYear"
        v-if="showSubmodel"
        :filter-method="filterMethod"
        :filters="getFilters('lineYear')"
      >
      </el-table-column>
      <el-table-column
        label="来源"
        prop="domestic"
        :filter-method="filterMethod"
        :filters="getFilters('domestic')"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<style>
.pl-table::before {
  height: 0;
}
.plTableBox .el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #ebeef5;
}
.plTableBox .el-table th.is-leaf,
.el-table td {
  border-bottom: 1px solid #ebeef5;
}
.plTableBox .el-table th {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.plTableBox .el-table td,
.el-table th {
  padding: 12px 0;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
}
.plTableBox .el-table th,
.el-table tr {
  background-color: #fff;
}
</style>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import SvgIcon from "../SvgIcon.vue";

export default {
  components: { SvgIcon },
  data() {
    return {
      selectedResult: [],
      showSubmodel: false,
      cname: this.currentTabName,
      lineWidth: 500,
    };
  },
  props: {
    showSelectionButton: { type: Boolean, default: true },
    resultExclusiveChoice: { type: Boolean, default: false },
  },
  mounted() {
    this.setDefaultFilterValue();
  },

  methods: {
    ...mapActions("commonsearch", ["getPivotTable"]),
    ...mapMutations("commonsearch", [
      "addSelectionResult",
      "setSearchSelectedResult",
      "clearResult",
    ]),
    setDefaultFilterValue() {
      // this.$refs.resultTable.getTableRef().columns[7].filteredValue = ['在产'];

      this.$nextTick(() => {
        //this.$refs.resultTable.columns[7].filteredValue = ['在产'];
        this.$refs.resultTable.store.states.columns.forEach((column) => {
          if (column.filteredValue && column.filteredValue.length) {
            this.$refs.resultTable.store.commit("filterChange", {
              column,
              values: column.filteredValue,
              silent: true,
            });
          }
        });
      });
    },
    sortMsrp(x,y){
       
         return Number(x.msrp)-Number(y.msrp);
    },
    changeTableSort(column){
     // alert(column.prop);
      if(column.prop=="msrp"){
        //  this.displayResult=this.displayResult.sort((a,b)=>Number(a[column.prop])-Number(b[column.prop]));
      }
    },
    clearResults() {
      this.clearResult();
    },
    onAddSelectionResult() {
      if (this.selectedResult.length <= 0) {
        this.$message({
          type: "error",
          message: "没有选中的车辆信息",
          duration: 2000,
        });
      } else {
        this.$emit("ActiveTab", "tabSelectionResult");
        this.addSelectionResult(this.selectedResult);
      }
    },

    msrpFormatter(row, column) {
      return parseInt(row.msrp);
    },
    // 选择列表结果列表
    onSelectionChanged(val) {
      //currentTabName = 'tabSeletionResult';

      if (this.showSubmodel) {
        this.selectedResult = val;
      } else {
        this.selectedResult = this.searchResult.filter((item) => {
          return (
            val.findIndex((obj) => {
              return item.model === obj.model;
            }) > -1
          );
        });
      }
      this.setSearchSelectedResult(this.selectedResult);
      //alert(JSON.stringify(val));
    },
    // 过滤
    filterMethod(value, row, col) {
      const prop = col["property"];
      return row[prop] == value;
    },
    // 生成过滤列表
    getFilters(prop) {
      const result = this.searchResult;
      return result
        .map((item) => {
          if (prop == "offlinedate" && !item[prop]) {
            return { text: "在产", value: item[prop] };
          } else {
            return { text: item[prop], value: item[prop] };
          }
        })
        .filter((item, index, arr) => {
          return (
            arr.findIndex((obj) => {
              return item.value === obj.value;
            }) === index
          );
        });
    },
    // 进入分析
    async gotoAnalyze() {
      if (this.searchResult && this.searchResult.length > 0) {
        let uri = await this.getPivotTable("search");
        console.log(uri);
        if (uri) {
          console.log(uri);
          this.$router.push({ name: "flexmonster" });
        }
      } else {
        this.$message({
          type: "error",
          message: "没有选中的车辆信息",
          duration: 2000,
        });
      }
    },

    getModels(result) {
      var map = {};
      var ret = [];
      for (var i = 0; i < result.length; i++) {
        var cur = result[i];

        if (!map[cur.modeId]) {
          ret.push(cur);
          map[cur.modeId] = 1;
        }
      }
      return ret;
    },
  },
  computed: {
    ...mapGetters("commonsearch", ["searchResult", "searchResultModel"]),
    showClearAll() {
      return this.searchResult.length > 0;
    },
    // 搜索结果
    displayResult() {
      // alert(this.hasSearchResult);
      this.setDefaultFilterValue();
      if (this.showSubmodel) {
        return this.searchResult;
      } else {
        // // 最小颗粒为子车型
        return this.searchResult.filter((item, index) => {
          return (
            this.searchResult.findIndex((obj) => {
              return obj.modeId === item.modeId;
            }) === index
          );
        });
        // return this.getModels(this.searchResult);
        // return this.searchResultModel;
      }
    },
  },
  watch: {
    showSubmodel(val) {
      if (val) {
        this.lineWidth = 150;
      } else {
        this.lineWidth = 500;
      }
    },
  },
};
</script>